import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'issueCharts',
    label: 'Issue Charts',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
